import { useQuery } from "@apollo/react-hooks";

import { QueryLearnerArgs } from "@hubcapp/types";

import learnerName from "../graph-ql/learnerName.graphql";

const useQueryLearnerName = (id?: QueryLearnerArgs["id"]) =>
  useQuery(learnerName, {
    skip: !id,
    variables: {
      id,
    },
  });

export default useQueryLearnerName;
